import { css } from 'lit';

var css_248z = css`:host{color:inherit;display:inline-flex}`;

export { css_248z as default };
//# sourceMappingURL=icons.styles.css.js.map
